// extracted by mini-css-extract-plugin
export default {"wrapper":"StatusContainer_wrapper__ngBUI"};